var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import omit from 'lodash/omit';
import React from 'react';
import Text from '../Text';
import EdsCheckbox from '@hedtech/react-design-system/core/es/Checkbox';
import { FormControlLabel as EdsFormControlLabel } from '@hedtech/react-design-system/core/es/FormControl';
import Tokens from '../styles/Tokens';
import { createStyles, withStyles } from '../styles/withStyles';
const styles = createStyles({
    focused: {
        margin: Tokens.spacingXxSmall
    },
    focusedNoMargin: {
        margin: 0
    },
    root: {
        margin: Tokens.spacingXxSmall
    },
    rootNoMargin: {
        margin: 0
    }
});
const Checkbox = (props) => {
    const { classes, className, error, helperText, label, noMargin, title } = props, rest = __rest(props, ["classes", "className", "error", "helperText", "label", "noMargin", "title"]);
    const classOverrides = omit(classes, ['focusedNoMargin', 'rootNoMargin']);
    if (noMargin) {
        classOverrides.focused = classnames(classes.focused, classes.focusedNoMargin);
        classOverrides.root = classnames(classes.root, classes.rootNoMargin);
    }
    const checkbox = (React.createElement(EdsCheckbox, Object.assign({ "aria-label": title ? title : label, classes: classOverrides, title: title ? title : label }, rest)));
    let errorMessage;
    if (error) {
        errorMessage = (React.createElement(Text, { color: "error", size: "small" }, helperText));
    }
    return (React.createElement(React.Fragment, null,
        label ?
            (React.createElement(EdsFormControlLabel, { className: className, control: checkbox, label: label })) : checkbox,
        errorMessage));
};
export default withStyles(styles)(Checkbox);
